module.exports = {"410423001":"露峰街道","410423002":"琴台街道","410423003":"鲁阳街道","410423004":"汇源街道","410423101":"下汤镇","410423102":"梁洼镇","410423103":"张官营镇","410423104":"张良镇","410423105":"尧山镇","410423106":"瓦屋镇","410423107":"赵村镇","410423201":"四棵树乡","410423202":"团城乡","410423203":"熊背乡","410423204":"让河乡","410423206":"观音寺乡","410423207":"昭平台库区乡","410423208":"背孜乡","410423209":"仓头乡","410423210":"董周乡","410423211":"张店乡","410423212":"辛集乡","410423213":"滚子营乡","410423214":"马楼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410423.json
// module id = 1681
// module chunks = 0